import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { FiClock, FiInfo } from "react-icons/fi";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import api from "../services/api";
//para pegar o ID da rota
import { useParams } from "react-router-dom";

import "../styles/pages/orphanage.css";
import Sidebar from "../components/Sidebar";
import mapIcon from "../utils/mapIcon";

interface RouteParams {
  id: string;
}

interface IOrphanage {
  latitude: number;
  longitude: number;
  name: string;
  about: string;
  instructions: string;
  opening_hours: string;
  open_on_weekends: string;
  whatsapp?: string;
  images: Array<{
    id: number;
    url: string;
  }>;
}

export default function Orphanage() {
  const params = useParams<RouteParams>();

  const [orphanage, setOrphanage] = useState<IOrphanage>();

  //seta a imagem ativa para trocar na exibicao, comeca em zero pois queremos a primeira
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    api.get(`/orphanages/${params.id}`).then((response) => {
      setOrphanage(response.data);
    });
  }, [params.id]);

  //se nao tiver carregado ainda mostra um carregando
  if (!orphanage) {
    return <p>Carregando...</p>;
  }

  return (
    <div id="page-orphanage">
      <Sidebar />

      <main>
        {/* Exibe a imagem principal com base o Index começando em zero pelo useState acima */}
        <div className="orphanage-details">
          <img
            src={orphanage.images[activeImageIndex].url}
            alt={orphanage.name}
          />

          {/* Exibe as proximas imagens com baixa opacidade e permite selecionar a proxima imagem
          a partir do useState */}
          <div className="images">
            {orphanage.images.map((image, index) => {
              return (
                <button
                  key={image.id}
                  // Se a imagem for a mesma do Index, coloque a classe active, se nao fique ofuscada
                  className={activeImageIndex === index ? "active" : ""}
                  type="button"
                  // ao clicar na imagem envie o indice pelo useState para a activeImageIndex
                  onClick={() => {
                    setActiveImageIndex(index);
                  }}
                >
                  <img src={image.url} alt={orphanage.name} />
                </button>
              );
            })}
          </div>

          <div className="orphanage-details-content">
            <h1>{orphanage.name}</h1>
            <p>{orphanage.about}</p>

            <div className="map-container">
              <MapContainer
                center={[orphanage.latitude, orphanage.longitude]}
                zoom={16}
                style={{ width: "100%", height: 280 }}
                dragging={false}
                touchZoom={false}
                zoomControl={false}
                scrollWheelZoom={false}
                doubleClickZoom={false}
              >
                <TileLayer url="https://a.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <Marker
                  interactive={false}
                  icon={mapIcon}
                  position={[orphanage.latitude, orphanage.longitude]}
                />
              </MapContainer>

              <footer>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://www.google.com/maps/dir/?api=1&destination=${orphanage.latitude},${orphanage.longitude}`}
                >
                  Ver rotas no google maps
                </a>
              </footer>
            </div>

            <hr />

            <h2>Instruções para visita</h2>
            <p>{orphanage.instructions}</p>

            <div className="open-details">
              <div className="hour">
                <FiClock size={32} color="#15B6D6" />
                Segunda a Sexta <br />
                {orphanage.opening_hours}
              </div>

              {orphanage.open_on_weekends ? (
                <div className="open-on-weekends">
                  <FiInfo size={32} color="#39CC83" />
                  Atendemos <br />
                  fim de semana
                </div>
              ) : (
                <div className="open-on-weekends dont-open">
                  <FiInfo size={32} color="#FF669D" />
                  Não Atendemos <br />
                  fim de semana
                </div>
              )}
            </div>

            <button type="button" className="contact-button">
              <a
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
                href={`https://web.whatsapp.com/send?text=Olá ${orphanage.name} estou entrando em contato para saber mais detalhes a respeito da visitação.&phone=55${orphanage.whatsapp}`}
              >
                <FaWhatsapp size={20} color="#FFF" />
                Entrar em contato
              </a>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

// https://web.whatsapp.com/send?phone=11974727191
